import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class AiUploadHistoryService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'aiuploadhistory/';
  }

  save(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllForJobMonitoring(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAllForJobMonitoring`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  // getAllForJobMonitoring
  getStats(): Observable<any> {
    return this.http.post(
      `${this.pathApi}getStats`,
      {},
      {
        headers: this.headers,
        observe: 'response',
      }
    );
  }
  process(obj: number): Observable<any> {
    return this.http.post(`${this.pathApi}processBatch`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getFeedersCount(): Observable<any> {
    return this.http.get(`${this.pathApi}getFeedersCount`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getTotalBatchImageSets(): Observable<any> {
    return this.http.get(`${this.pathApi}getTotalBatchImageSets`, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
